export default function() {
  return { 
    state: {}, 
    $nextTick: () => {} 
  };
}